/**
 * @generated SignedSource<<b104e7eab57e327a449d3b9ba09c3e22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamHeaderAssignedBadgeSubscription$variables = {
  employeeId?: string | null;
};
export type TeamHeaderAssignedBadgeSubscription$data = {
  readonly storeViewerAssignedCountChanged: {
    readonly assignedCount: number;
    readonly id: string;
  };
};
export type TeamHeaderAssignedBadgeSubscription = {
  response: TeamHeaderAssignedBadgeSubscription$data;
  variables: TeamHeaderAssignedBadgeSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "employeeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "employeeId",
        "variableName": "employeeId"
      }
    ],
    "concreteType": "StoreViewer",
    "kind": "LinkedField",
    "name": "storeViewerAssignedCountChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamHeaderAssignedBadgeSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamHeaderAssignedBadgeSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9324a4b456aa012c8885f6e653ff7cf7",
    "id": null,
    "metadata": {},
    "name": "TeamHeaderAssignedBadgeSubscription",
    "operationKind": "subscription",
    "text": "subscription TeamHeaderAssignedBadgeSubscription(\n  $employeeId: ID\n) {\n  storeViewerAssignedCountChanged(employeeId: $employeeId) {\n    id\n    assignedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7babb401a1626ea4d99a8fcaa3e3bca";

export default node;
